import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'haven-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FooterComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
